import { InjectionToken } from '@angular/core';

export interface AppFeature {
  /* Enable dark mode feature using system preference, set to false by default 
    enabling this feature allows the application to switch between light and dark mode based on user system settings
    ie. if user's phone changes the settings to dark mode, the application will also use dark mode based on this setting
  */
  enableDarkMode?: boolean;
}

/* Injection token for application features, all app feature settings should be added here */
export const APP_FEATURE = new InjectionToken<AppFeature>('AppFeature');
